import { render, staticRenderFns } from "./DropHere.vue?vue&type=template&id=0c717762&scoped=true&"
import script from "./DropHere.vue?vue&type=script&lang=ts&"
export * from "./DropHere.vue?vue&type=script&lang=ts&"
import style0 from "./DropHere.vue?vue&type=style&index=0&id=0c717762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c717762",
  null
  
)

export default component.exports